import React from 'react';
import { T } from '@colonist/ui';
import { PatchNoteContentItem } from './PatchNoteContentItem/PatchNoteContentItem.tsx';
import styles from './PatchNoteVersionSection.module.scss';
export function PatchNoteVersionSection({ patchNote, onExternalClick, onProfileClick }) {
    const dateFormatParams = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    const dateTitle = {
        key: 'strings:colonistCommon.utils.#date',
        options: {
            value: patchNote.date,
            formatParams: {
                value: dateFormatParams
            }
        }
    };
    const versionTitle = {
        key: 'strings:popups.patchNote.version',
        options: {
            version: patchNote.version
        }
    };
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: styles.header
    }, /*#__PURE__*/ React.createElement("h3", {
        className: styles.date
    }, /*#__PURE__*/ React.createElement(T, {
        id: dateTitle
    })), /*#__PURE__*/ React.createElement("h4", {
        className: styles.version
    }, /*#__PURE__*/ React.createElement(T, {
        id: versionTitle
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.body
    }, patchNote.contents.map((content, index)=>/*#__PURE__*/ React.createElement(PatchNoteContentItem, {
            key: index,
            content: content,
            onExternalClick: onExternalClick,
            onProfileClick: onProfileClick
        }))));
}
